import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAiSE6-KADSOOWL_MUBsNxSO6_LX3gNHKw",
  authDomain: "reservation-platform-prod.firebaseapp.com",
  projectId: "reservation-platform-prod",
  storageBucket: "reservation-platform-prod.firebasestorage.app",
  messagingSenderId: "203844526826",
  appId: "1:203844526826:web:4bb14afee5c9d44e2f2d93",
  measurementId: "G-L2P9CJM7XE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'asia-northeast1');

export default app;
